import JamesTownLogo from "./../../assets/images/james-logo2.png";
import { showErrorToast } from "../../utils/toast";
import { useMutation } from "react-query";
import { loginAdmin } from "../../api/auth";
import { useLoginEffect } from "./effect";
import { useEffect } from "react";

const imageStyle = {
  backgroundImage: `url('${JamesTownLogo}')`,
  backgroundSize: "contain",
  backgroundPosition: "center",
  height: "41px",
  width: "150",
  backgroundRepeat: "no-repeat",
};

export default function Login() {
  // explain why the admin was signed out (e.g. account deactivated)
  useEffect(() => {
    try {
      const reason = sessionStorage.getItem("signedOutReason");
      if (reason) {
        sessionStorage.removeItem("signedOutReason");
        showErrorToast(reason);
      }
    } catch (e) {}
  }, []);

  const mutation = useMutation(loginAdmin, {
    onSuccess: (data) => {
      const hasDashboard = data?.permissions?.find(perm => perm.module.toLowerCase() === "dashboard")?.permissions?.canView;

      const allViewPermissions = data?.permissions?.filter(perm => perm.permissions.canView);
      const firstViewPermissions = allViewPermissions?.[0];
      const permList = [{ module: "Banner", route: "/settings/banners"}, { module: "Notification", route: "/notifications"}, { module: "Role", route: "/settings/roles"}, { module: "Customer", route: "/customers"}, { module: "Trade", route: "/trades"}, { module: "Rate", route: "/rates" }, { module: "Monitoring", route: "/monitoring" }, { module: "Watchlist", route: "/bvn-watchlist" }, { module: "Withdrawal", route: "/withdrawals" }];
      const gotoRote = permList.find(perm => perm.module === firstViewPermissions.module)?.route;
      
      if (data?.permissions) {
        localStorage.setItem('permissions', JSON.stringify(data.permissions));
      }
      if (hasDashboard) {
        return window.location = window.location.origin;
      }
      if (gotoRote) {
        return window.location = gotoRote
      }
      window.location = '/settings'
    },
    onError: (e) => showErrorToast(e.message),
  });

  const { handleLogin } = useLoginEffect();

  const onSubmit = (e) => {
    const data = handleLogin(e);
    mutation.mutate(data);
  };

  return (
    <div className="w-full h-screen items-center justify-center flex flex-col">
      <div className="flex flex-col gap-5">
        <div className="">
          <div className="" style={imageStyle}></div>
        </div>
        <div className="text-center font-dmsans space-y-1">
          <div className="leading-[38px] text-[27px] font-bold text-[#101828]">
            Log in to your account
          </div>
          <div className="leading-[24px] text-[14px] font-normal text-[#667085]">
            Welcome back! Please enter your details.
          </div>
        </div>
        <div className="font-Neurial w-[400px]">
          <form onSubmit={(e) => onSubmit(e)}>
            <div className="flex flex-col gap-5">
              <div className="space-y-1">
                <div className="font-normal text-[#181819E5] text-[15px]">
                  Email
                </div>
                <div className="">
                  <input
                    type="text"
                    className="border-[#E6E7E9] placeholder:text-[#A0A3BD] text-[13px] w-full border-[1px] px-4 py-3 rounded-lg"
                    placeholder="Email"
                    name="email"
                  />
                </div>
              </div>
              <div className="space-y-1">
                <div className="font-normal text-[#181819E5] text-[15px]">
                  Password
                </div>
                <div className="">
                  <input
                    type="password"
                    className="border-[#E6E7E9] placeholder:text-[#A0A3BD] text-[13px] w-full border-[1px] px-4 py-3 rounded-lg"
                    placeholder="Password"
                    name="password"
                  />
                </div>
              </div>
              <div className="">
                <button
                  disabled={mutation.isLoading}
                  className="w-full bg-dark text-white p-3 rounded-[5px] font-bold"
                  type="submit"
                >
                  {mutation.isLoading ? "Loading..." : "Login"}
                </button>
              </div>
              <div className="flex flex-col items-center">
                <button className="text-[#2121F1] bg-none font-inter font-medium text-[14px] cursor-pointer">
                  Forgot Password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
